import Blockchain from './enums/blockchain-enum';

export default class Tools {
  public static shortenText(text: string, numberOfChars?: number): string {
    const chars = numberOfChars ?? 8;
    if (text && text.length > chars * 2 + 1) {
      const result = `${text.substring(0, chars)}...${text.substring(text.length - chars)}`;
      return result;
    }

    return text;
  }

  public static getNetworkName(networkId?: string | number): string {
    switch (networkId) {
      case 1: {
        return Blockchain.Ethereum;
      }
      case 8217: {
        return Blockchain.Klaytn;
      }
      case -1: {
        return Blockchain.Counterparty;
      }
      case -2: {
        return Blockchain.FirstOasisKlaytn;
      }
      default: {
        return 'Not supported';
      }
    }
  }

  public static getNetworkLongName(networkId?: string | number): string {
    switch (networkId) {
      case -2: {
        return 'First Oasis';
      }
      case -1:
      case 1:
      case 8217:
      default: {
        return Tools.getNetworkName(networkId);
      }
    }
  }

  public static extractAccount(accounts: string | string[]): string {
    return Array.isArray(accounts) ? accounts[0] : accounts;
  }

  public static capitalizeFirstLetter(text: unknown): string {
    const str = `${text}`;
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  public static convertDate(seconds: string): string {
    const date: Date = new Date(0);
    date.setUTCSeconds(Number.parseInt(seconds, 10));
    return `${date.getFullYear()}-${`0${date.getMonth() + 1}`.slice(-2)}-${`0${date.getDate()}`.slice(
      -2
    )} ${`0${date.getHours()}`.slice(-2)}:${`0${date.getMinutes()}`.slice(-2)}`;
  }

  public static removeDuplicates(items: string[]): string[] {
    return items.filter((v, i, a) => a.indexOf(v) === i && v);
  }

  public static validateEmail(email: string): boolean {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }
}
